import {useMemo} from 'react'
import {logger} from 'tizra'

const log = logger('quickstart/hooks/useHostnameSuffix')

const WINDOW = typeof window === 'undefined' ? undefined : window

export const useHostnameSuffix = () =>
  useMemo(() => {
    // Don't use location from react router because it doesn't include hostname.
    const match = log.tap(
      (WINDOW?.location.hostname || '').match(
        /^s\d+-(\w+)\.(?:dev\.agilepublisher|tizrapublisher)\.com$/,
      ),
    )
    return match?.[1]
  }, [])
